import i18n from "src/app/shared/localization/i18n"
import { ChannelType } from "src/app/contact/~store/models/ChannelType";

export const HEIGHT_OF_OPERATORITEM_IN_REM: number = 3.5;
export const HEIGHT_OF_NO_OPERATORS_DIV_IN_REM: number = 3;
export const HEIGHT_OF_DROPDOWN_HEADER_IN_REM: number = 3;
export const HEIGHT_OF_LOADER_IN_REM: number = 2;

export const INPUT_LINES_COUNT: number = 10;

export const INPUT_SYMBOLS_COUNT: number = 2000;

export const INSTAGRAM_INPUT_SYMBOLS_COUNT: number = 1000;

export const WECHAT_INPUT_SYMBOLS_COUNT: number = 600;

export const EDIT_MESSAGE_WRONG_CHANNEL_TYPE_MESSAGE: string = i18n.t('chat.cannotEditMessageWrongChannelType');

export const SEND_FILE_MESSAGE_ERROR = i18n.t('chat.sendFileMessageError')

export const SUPPORTED_EDIT_CHANNELS = [
    ChannelType.Telegram,
    ChannelType.TelegramPrivate,
    ChannelType.Widget,
    ChannelType.Vk
];

export const SUPPORTED_REPLY_CHANNELS = [
    ChannelType.Telegram,
    ChannelType.WhatsApp,
    ChannelType.Instagram,
    ChannelType.Facebook,
    ChannelType.TelegramPrivate,
    ChannelType.Widget,
];

export const MESSAGE_DELETED_SYSTEM_TAG = 'system-message-delete-action';